import { render, staticRenderFns } from "./show-notifications.vue?vue&type=template&id=4b0cc8d6&scoped=true"
import script from "./show-notifications.vue?vue&type=script&lang=js"
export * from "./show-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0cc8d6",
  null
  
)

export default component.exports